module.exports = __webpack_public_path__ + "img/default_networkanomaly.d9b44b23.png";